import { useEffect, useCallback, useRef } from 'react';
// ---- external imports ----

import useMountEffect from './useMountEffect';
// ---- local imports ----


function useBringOnTop(element, isOnTop) {
	const elRef = useRef();

	const onMouseDown = useCallback(() => {
		if (!elRef || !elRef.current) {
			return;
		}

		assignNewZIndex(elRef.current);
	}, []);

	useMountEffect(initZIndex);

	useEffect(() => {
		const isSupported = element && element.addEventListener;
		if (!isSupported) {
			return;
		}

		elRef.current = element;
		elRef.current.addEventListener('mousedown', onMouseDown);
		assignNewZIndex(elRef.current);

		return () => {
			elRef.current.removeEventListener('mousedown', onMouseDown);
		};
	}, [element, onMouseDown]);

	useEffect(() => {
		if (!element || isOnTop === undefined)
			return;

		if (isOnTop) {
			assignNewZIndex(element);
		} else {
			resetZIndex(element);
		}
	}, [isOnTop, element]);
};

function initZIndex() {
	if (!document.traders) {
		document.traders = {};
	}

	if (!document.traders.zIndex) {
		document.traders.zIndex = 1;
	}
}

function assignNewZIndex(element) {
	if (document.traders.zIndex === parseInt(element.style.zIndex)) {
		return;
	}

	element.style.zIndex = getNextZIndex();
}

function getNextZIndex() {
	return ++document.traders.zIndex;
}

function resetZIndex(element) {
	element.style.zIndex = 0;
}

export default useBringOnTop;
